import { TabPanel } from '@mui/lab';
import { Box } from '@mui/material';

type SchedulerToolbarFormProps = {
  langCode: string;
  index: number;
  displayFieldSet: (index: number) => React.ReactNode;
  'data-testid': string;
  multiLanguageEnable: boolean;
};

const DisplayLanguageTabPanel = ({
  langCode,
  index,
  displayFieldSet,
  'data-testid': dataTestId,
  multiLanguageEnable,
}: SchedulerToolbarFormProps) => {
  return (
    <TabPanel
      value={langCode}
      key={langCode}
      data-testid={dataTestId}
      sx={{ px: 0, pb: 0, pt: multiLanguageEnable ? 1 : 0 }}
    >
      <Box display="grid" key={index}>
        {displayFieldSet(index)}
      </Box>
    </TabPanel>
  );
};

export default DisplayLanguageTabPanel;
